<template>
  <v-container>
    <v-btn fixed dark fab bottom right color="pink" v-on:click="createNew">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-data-table :items="users" :headers="headers" :loading="isBusy"
                  @click:row="editSelected" disable-pagination hide-default-footer
                  fixed-header disable-sort class="row-pointer">
      <template v-slot:item.lastVisit="{ item }">
        <span>{{ $moment(item.lastVisit).format('YYYY-MM-DD') }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: 'Users',
  data() {
    return {
      isBusy: false,
      headers: [
        {value: 'name', text: 'Имя'},
        {value: 'nickname', text: 'Псевдоним'},
        {value: 'flat', text: 'Квартира'},
        {value: 'lastVisit', text: 'Посещение'},
        {value: 'isAdmin', text: 'isAdmin'},
      ],
      users: []
    }
  },
  mounted() {
    this.isBusy = true
    this.$http("/user")
        .then(resp => this.users = resp.data)
        .finally(() => this.isBusy = false)
  },
  methods: {
    createNew: function() {
      console.log("createNew ")
      this.$router.push({name: 'UserEdit', params: {userId: null}})
    },
    editSelected: function (item) {
      // const houseId = item.id
      console.log("onClickRow ", item)
      this.$router.push({name: 'UserEdit', params: {userId: item.id}})
    }
  }
}

</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>